// JS se encarga de sumar o restar el valor de inputs de cantidad, Ej boton de mas y menos en cantidad vista PRODUCTOS

$(document).ready(function(){
    // variables

    // acciones
    $('body').on('click', '.js-quanty__minus', function(event) { 
        event.preventDefault()
        quantyMinus($(this))
    })

    $('body').on('click', '.js-quanty__plus', function(event) {
        event.preventDefault()
        quantyPlus($(this))
    })

    $('body').on('change', '.js-quanty__input', function(event) {
        quantyInput($(this))
        quantyText($(this))
    })

    // funciones
    function quantyMinus(action) {
        $('.js-quanty__input').each( function (){
            if (action.data('quanty__id') == $(this).data('quanty__id')) {
                if ( ($(this).val()/1) > 1 ) {
                    $(this).val( ($(this).val()/1) - 1 )
                    quantyText($(this))
                }
            }
        })
    }

    function quantyPlus(action) {
        $('.js-quanty__input').each( function (){
            if (action.data('quanty__id') == $(this).data('quanty__id')) {
                $(this).val( ($(this).val()/1) + 1 )
                quantyText($(this))

                if ( ($(this).val()/1) > ($(this).attr('max')/1) ) {
                    $(this).val( ($(this).attr('max')/1) )
                    quantyText($(this))
                }
            }
        })
    }

    function quantyInput(action) {
        if ( (action.val()/1) > (action.attr('max')/1) ) {
            action.val( (action.attr('max')/1) )
        }
        if ( (action.val()/1) <= 0 ) {
            action.val(1)
        }
    }

    function quantyText(action) {
        $('.js-quanty__text').each( function (){
            if (action.data('quanty__id') == $(this).data('quanty__id')) {
                $(this).html( action.val() )
            }
        })
    }

})
